import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <p
    className={`text-xs font-medium uppercase tracking-[0.25em] ${
      dark ? "text-gold-champagne" : "text-gold-dark"
    }`}
  >
    {children}
  </p>
);

export const Sparkle = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 0c.9 6.9 5.1 11.1 12 12-6.9.9-11.1 5.1-12 12-.9-6.9-5.1-11.1-12-12C6.9 11.1 11.1 6.9 12 0z" />
  </svg>
);
